import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { LoanSelector } from "./LoanSelector";
import { TermSelector } from "./TermSelector";
import { useCalculator } from "../hooks";
import { LoanAmount } from "../LoanAmount";
import "./index.css";
import { selectLoan } from "@/store/selectors";

export const CalculatorMobile = ({ calculatorType }) => {
  const amounts = useSelector(selectLoan);

  const {
    days,
    weeks,
    loanItems,
    periodItems,
    getSumScaleItem,
    getPeriodScaleItem,
    calculatorSettings,
    recalculateOnChangeLoan,
    recalculateOnChangePeriod,
  } = useCalculator(calculatorType);

  const loading = Object.entries(calculatorSettings).length === 0;
  const selectedLoan = loanItems.find((i) => i.number === amounts.loanAmount);
  const selectedTerm = periodItems.find(
    (i) => i.number === amounts.term && amounts.periodTypeId === i.periodTypeId
  );

  const hasDaysAndWeeks = days?.length > 0 && weeks?.length > 0;

  return (
    <ul className={classNames("mobile-calculator", "form-list", { loading })}>
      <LoanSelector
        selected={selectedLoan}
        items={loanItems}
        onSelect={(item) => recalculateOnChangeLoan(item.number)}
      />
      <li className="item">
        <ul className="item_list">
          <li>{getSumScaleItem(0)}</li>
          <li>{getSumScaleItem(1)}</li>
          <li>{getSumScaleItem(2)}</li>
        </ul>
      </li>
      <LoanAmount />
      <TermSelector
        selected={selectedTerm}
        items={periodItems}
        onSelect={(item) => recalculateOnChangePeriod(item)}
      />
      <li className="item">
        <ul className="item_list">
          {hasDaysAndWeeks && <li>{getPeriodScaleItem(0)}</li>}
          <li className={hasDaysAndWeeks ? "second-item" : ""}>
            {getPeriodScaleItem(1)}
          </li>
          <li>{getPeriodScaleItem(2)}</li>
        </ul>
      </li>
    </ul>
  );
};
